import React from 'react';
import { setImage } from '../../helper';
import noImage from '../../../assets/images/no-image.png';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';

export function Navigation(props) {
  const { fromForm, dataIndex, editingInput, deleteItem, dppAddEditAccess, onClick, isProductArchived } = props;
  return (
    <div className="navigation-control">
      {props?.anchorMenu?.length === 0 ? (
        <div className="empty-navigation">
          <i className="icon icon-DAM-1" />
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center">
          {props?.anchorMenu?.map((vl, i) => {
            return (
              <div key={i} name={vl.id} onClick={() => onClick(vl.id)} className="navigation-icons">
                <figure>
                  <img src={vl?.defaultIcon ? setImage(vl?.defaultIcon?.replace(/^\/react-app/, '')) : noImage} alt="" />
                </figure>
                <figcaption>{vl?.displayLabel}</figcaption>
              </div>
            );
          })}
        </div>
      )}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default Navigation;
